import {uiEventLoggerCreator} from '@web/middlewares/uiLogging'

/**
 * 이벤트 로그 수집 동작을 관리하는 미들웨어
 */
const uiLogTracker = uiEventLoggerCreator({})

export default uiLogTracker
